import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import Filters from "../components/Filters";
import Items from "../components/Items";
import { getSeries } from "../redux/modelsComparatorSlice";
import useGetTranslations from "../../../../../dealers/assets/js/dealers_map/hooks/useGetTranslations";

export default function Comparator({ contact, locale, quotation, testDrive }) {
    const [translations] = useGetTranslations(
        // locale,
        "/api/vehicles/get_translations/"
    );

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getSeries(locale));
    }, []);

    return (
        <div
            className="comparator"
            style={{ backgroundImage: "url(/static/vehicles/images/bg.png)" }}
        >
            <div className="title-and-button">
                <div className="wrapper">
                    <span className="text">
                        <div className="title">
                            {translations.text2}
                            <br />
                            {translations.text3}
                        </div>
                    </span>
                    <a
                        href={contact}
                        type="button"
                        className="btn-large btn-primary-black"
                    >
                        {translations.text1}
                    </a>
                </div>
            </div>

            <div className="wrapper comparator-container">
                <Filters />

                <div className="comparator-content">
                    <Items id="firstItem" quotation={quotation} testDrive={testDrive} />
                    <Items id="secondItem" quotation={quotation} testDrive={testDrive} />
                    <Items id="thirdItem" quotation={quotation} testDrive={testDrive} />
                </div>
            </div>
        </div>
    );
}
